window.addQuickModalToProductCards =  function () {
    const modal = document.getElementById('product-modal');
    const openModalBtns = Array.from(document.querySelectorAll('.open-modal-btn'));

    document.addEventListener('click', (event) => {
        if (event.target.classList.contains('close-modal')) {
            modal.close();
        }
    });

    modal.addEventListener('cancel', (event) => {
        event.preventDefault();
        modal.close();
    });

    function updateVariantSelected(variantId, bundleOptions) {
        const productVariants = document.querySelector('.product-variants');

        if (bundleOptions && bundleOptions.length > 1) {
            const allOptions = Array.from(productVariants.children || [])
            const selectedOption = allOptions.find(option => bundleOptions.every(optionSelected => option.innerText.includes(optionSelected)));

            if (selectedOption) {
                selectedOption.selected = true;
                return
            }

        }

        const selectedOption = productVariants.querySelector(`option[value="${variantId}"]`);
        selectedOption.selected = true;
    }

    function closeModalOnAtc() {

        const form = document.querySelector('.js-quick-add-modal');

        form.addEventListener('submit', (event) => {

            const swatchActive = document.querySelector('.modal-swatch[data-active="true"]');
            const swatchUnavailable = swatchActive?.classList.contains('unavailable-swatch');

            if (!swatchUnavailable) {
                setTimeout(() => {
                    modal.close();
                }, 500);
            }
        });
    }

    function updateVariantImage(variantImage) {
        if (!variantImage || variantImage.includes("no-image")) return;
        const productImage = document.getElementById('modal-product-image');

        productImage.classList.remove('fade-in');
        productImage.classList.add('fade-out');

        setTimeout(() => {
            productImage.src = variantImage;

            productImage.onload = () => {
                productImage.classList.remove('fade-out');
                productImage.classList.add('fade-in');
            };
        }, 100);
    }


    function listenToCloseModal() {

        const closeBtn = document.querySelector('.close-modal');
        closeBtn?.addEventListener('click', () => {
            modal.close();
        });

        document.addEventListener('click', (event) => {
            const modalBox = document.getElementById('shopify-section-quick-add-modal-static');
            const isClickOutside = (!modalBox.contains(event.target)) && modal.open;

            if (isClickOutside) {
                modal.close();
            }
        });
    }

    function updateVariantPrice(variantPrice) {
        const productPrice = document.getElementById('modal-product-price');
        if (productPrice) productPrice.textContent = variantPrice;
    }

    function updateSahdes(shade, swatchesContainer) {
        const productShade = swatchesContainer?.querySelector('.modal-product-current-shade') || document.querySelector('.modal-product-current-shade');
        if (productShade) productShade.textContent = shade;
    }

    function handleVariantSwatchClick(event) {
        //abort if the swatch is unavailable
        if (event.target.classList.contains('unavailable-swatch')) {
            return;
        }

        const variantId = event.target.getAttribute('data-variant-id');
        const variantImage = event.target.getAttribute('data-variant-image');
        const price = event.target.getAttribute('data-variant-price');
        const shade = event.target.getAttribute('data-variant-shade');

        const swatchesContainer = event.target.closest('.swatches-outer-container');
        updateSahdes(shade, swatchesContainer);
        updateVariantPrice(price);
        updateVariantImage(variantImage);

        const variantSwatches = Array.from(swatchesContainer?.querySelectorAll('.modal-swatch') || document?.querySelectorAll('.modal-swatch'));
        variantSwatches?.forEach((swatch) => swatch.dataset.active = false);
        event.target.dataset.active = true;

        let bundleOptions = Array.from(document.querySelectorAll('.modal-swatch[data-active="true"]')).map((swatch) => swatch.getAttribute('data-value'))
        updateVariantSelected(variantId, bundleOptions);

    }

    function removeQueryParams(url) {
        return url.replace(/\?.*$/, '');
    }

    function openModal(button) {
        let productUrl = button.getAttribute('data-product-url');
        productUrl = removeQueryParams(productUrl);
       
        fetch(productUrl + `?sections=quick-add-modal-static`)
            .then((response) => response.json())
            .then((html) => {

                const parser = new DOMParser();
                const parsedDocument = parser.parseFromString(html["quick-add-modal-static"], 'text/html');
                const content = parsedDocument.body.innerHTML; // Extraer el contenido del <body>

                modal.innerHTML = content;

                const variantSwatches = Array.from(modal.querySelectorAll('.modal-swatch'));
                variantSwatches.forEach((swatch) => swatch.addEventListener('click', handleVariantSwatchClick));

                modal.showModal();
                closeModalOnAtc();
                listenToCloseModal();
            });
    }


    openModalBtns
        .forEach((button) => {
            if(button.getAttribute('data-product-has-modal')) return;
            button.addEventListener('click', () => openModal(button))
            button.setAttribute('data-product-has-modal', 'true');

        })
}

document.addEventListener('DOMContentLoaded', () => {
    addQuickModalToProductCards();
});